<template>
    <Bar :id="id" :data="chartData" :options="options" />
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { Bar } from 'vue-chartjs';

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

@Component({
    components: {
        Bar
    }
})
export default class BarChart extends Vue {
    @Prop({ required: true, type: String })
    id!: string;

    @Prop({ required: true, type: Object })
    chartData!: any;

    @Prop({ required: true, type: Object })
    options!: object;
}
</script>

